import React from "react";

export default function Stat({ label, value }) {
  return (
    <div className="border-l-2 border-[#FEBA01] pl-3">
      <div className="font-display text-3xl text-[#FEBA01]">{value}</div>
      <div className="font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3]">{label}</div>
    </div>
  );
}
